import { Box, Button } from '@mui/material';
import { TicketsAlertIcon } from '@tix-ticketing/ui-icons/feature';
import type { ReactNode } from 'react';
import { SwipableDialog } from './swipable-dialog';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel: ReactNode;
  cancelLabel: ReactNode;
  /** Feature icon above the title. Defaults to `TicketsAlertIcon`. */
  icon?: ReactNode;
  /** Shows a spinner on the confirm button and disables the cancel button. */
  pending?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  /** Extra content between the description and the buttons, e.g. a warning. */
  children?: ReactNode;
}

// Bottom sheet on mobile, modal on desktop.
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  icon = <TicketsAlertIcon />,
  pending = false,
  onConfirm,
  onClose,
  children,
}: ConfirmDialogProps) {
  return (
    <SwipableDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      headerIcon={icon}
      headerText={title}
      subtitleText={description}
      primaryActionButton={
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          loading={pending}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      }
      secondaryActionButton={
        <Button
          variant="contained"
          color="monochrome"
          size="large"
          fullWidth
          disabled={pending}
          onClick={onClose}
        >
          {cancelLabel}
        </Button>
      }
    >
      {/* The modal template leaves 40px between the content and the buttons. */}
      {children && <Box sx={{ pb: 2 }}>{children}</Box>}
    </SwipableDialog>
  );
}
